//
//
//
//
//
//

import noUiSlider from 'nouislider';

const formatter = {
  to: (input) => `${parseInt(input, 10)}%`, // convert to the range slider display format
  from: (sliderValue) => parseInt(sliderValue.replace('%', ''), 10), // convert back to an integer
};

export default {
  name: 'DpSlider',
  props: {
    value: { type: Number, default: 0 },
    percent: { type: Boolean, default: false },
    range: { type: Object, default: () => ({ min: 0, max: 100 }) },
    orientation: { type: String, default: () => 'horizontal' },
  },
  data() {
    return {
      slider: null,
    };
  },
  watch: {
    value(newValue) {
      this.slider.set([newValue]);
    },
  },
  mounted() {
    this.create();
  },
  beforeDestroy() {
    if (this.slider) {
      this.slider.off('change');
    }
  },
  methods: {
    create() {
      const args = {
        orientation: this.orientation,
        range: this.range,
        start: [this.value],
        step: 1,
        direction: 'ltr',
        pips: { mode: 'range', density: 3 },
        tooltips: true,
      };

      if (this.percent === true) {
        args.tooltips = formatter;
      }

      this.slider = noUiSlider.create(this.$refs.slider, args);

      this.slider.on('change', this.handleChange);
    },
    handleChange() {
      const value = parseInt(this.slider.get(), 10);
      this.$emit('input', value);
      this.$emit('change', value);
    },
  },
};
